(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
function bbInitAccessoryVariants(scope) {
  scope.querySelectorAll('[data-bb-accessory-root]').forEach(root => {
    if (root.dataset.accessoryReady) return;
    root.dataset.accessoryReady = 'true';
    const select = root.querySelector('select[name="id"]');
    const price = root.querySelector('[data-accessory-price]');
    if (!select || !price) return;
    const update = () => {
      const option = select.selectedOptions[0];
      if (option) price.textContent = option.dataset.price;
    };
    select.addEventListener('change', update);
    update();
  });
}
bbInitAccessoryVariants(document);
document.addEventListener('shopify:section:load', event => bbInitAccessoryVariants(event.target));

function bbInitPaymentChoices(scope) {
  scope.querySelectorAll('[data-bb-payment-root]').forEach(root => {
    if (root.dataset.paymentReady) return;
    const choices = root.querySelectorAll('[data-bb-payment]');
    const form = root.querySelector('.bb-product-form');
    if (!choices.length || !form) return;
    root.dataset.paymentReady = 'true';
    const button = form.querySelector('button[type="submit"]');
    const status = root.querySelector('[data-bb-payment-status]');
    const originalLabel = button.textContent;
    const originallyDisabled = button.disabled;
    const update = () => {
      const full = root.querySelector('[data-bb-payment]:checked')?.value === 'full';
      button.disabled = originallyDisabled || full;
      button.textContent = full ? root.querySelector('.bb-product-price-box--full>span').textContent : originalLabel;
      status.hidden = !full;
    };
    choices.forEach(choice => choice.addEventListener('change', update));
    form.addEventListener('submit', event => {
      if (root.querySelector('[data-bb-payment]:checked')?.value === 'full') {
        event.preventDefault();
        event.stopImmediatePropagation();
        update();
      }
    }, true);
    update();
  });
}
bbInitPaymentChoices(document);
document.addEventListener('shopify:section:load', event => bbInitPaymentChoices(event.target));

if (!customElements.get('bb-product-gallery')) {
  customElements.define('bb-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.bb-product-media');
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-count]');
      if (!this.track || !this.counter) return;
      this.update = () => {
        this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.counter.textContent = (this.index + 1) + ' / ' + this.track.children.length;
        this.previous.disabled = this.index === 0;
        this.next.disabled = this.index >= this.track.children.length - 1;
      };
      this.move = delta => this.track.scrollTo({
        left: Math.max(0, Math.min(this.track.children.length - 1, this.index + delta)) * this.track.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
